import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { InstallPrompt } from "@/components/InstallPrompt";
import { UpdateBanner } from "@/components/UpdateBanner";
import { PushOptInPrompt } from "@/components/PushOptInPrompt";
import Home from "@/pages/Home";
import CarDetail from "@/pages/CarDetail";
import Wishlist from "@/pages/Wishlist";
import RequestCar from "@/pages/RequestCar";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminCars from "@/pages/AdminCars";
import AdminCarForm from "@/pages/AdminCarForm";
import AdminRequests from "@/pages/AdminRequests";
import AdminReservations from "@/pages/AdminReservations";
import AdminSettings from "@/pages/AdminSettings";
import AdminNewsletter from "@/pages/AdminNewsletter";
import AdminReviews from "@/pages/AdminReviews";
import SellCar from "@/pages/SellCar";
import Compare from "@/pages/Compare";
import AdminSellOffers from "@/pages/AdminSellOffers";
import Insurance from "@/pages/Insurance";
import Demolition from "@/pages/Demolition";
import AdminDocumentRequests from "@/pages/AdminDocumentRequests";
import PaypalReturn from "@/pages/PaypalReturn";
import PaypalCancel from "@/pages/PaypalCancel";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/auto/:id" element={<CarDetail />} />
          <Route path="/preferiti" element={<Wishlist />} />
          <Route path="/richiedi" element={<RequestCar />} />
          <Route path="/vendi" element={<SellCar />} />
          <Route path="/confronta" element={<Compare />} />
          <Route path="/assicurazione" element={<Insurance />} />
          <Route path="/demolizione" element={<Demolition />} />
          <Route path="/contatti" element={<Contact />} />
          <Route path="/paypal/return" element={<PaypalReturn />} />
          <Route path="/paypal/cancel" element={<PaypalCancel />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/cars" element={<AdminCars />} />
          <Route path="/admin/cars/new" element={<AdminCarForm />} />
          <Route path="/admin/cars/:id/edit" element={<AdminCarForm />} />
          <Route path="/admin/requests" element={<AdminRequests />} />
          <Route path="/admin/reservations" element={<AdminReservations />} />
          <Route path="/admin/sell-offers" element={<AdminSellOffers />} />
          <Route path="/admin/insurance" element={<AdminDocumentRequests kind="insurance" />} />
          <Route path="/admin/demolition" element={<AdminDocumentRequests kind="demolition" />} />
          <Route path="/admin/settings" element={<AdminSettings />} />
          <Route path="/admin/newsletter" element={<AdminNewsletter />} />
          <Route path="/admin/reviews" element={<AdminReviews />} />
        </Routes>
      </BrowserRouter>
      <InstallPrompt />
      <UpdateBanner />
      <PushOptInPrompt />
      <Toaster
        position="top-right"
        richColors
        toastOptions={{
          style: {
            fontFamily: "Manrope, sans-serif",
            borderRadius: "4px",
          },
        }}
      />
    </div>
  );
}

export default App;
